module.exports = function() {
	return new Worker(__webpack_public_path__ + "4c65de373b6aeb695f1b.layers.wrkr.js");
};